import { Alpine } from '../../core/alpine-core.js';
import { apiFetch } from '../api.js';
import { stripLeagueFromAdminPath } from '../league-context.js';
import { buildLeagueRulesSummaryLines } from '../league-rules-summary.js';

Alpine.data('leagueRulesList', () => ({
  items: [],
  loading: true,
  refreshSpinning: false,
  firstLoad: true,
  viewOpen: false,
  viewTitle: '',
  viewSummaryText: '',
  viewRowId: null,

  async init() {
    await this.reload();
    this.firstLoad = false;
  },

  rulesNewHref() {
    return '/admin/league-rules/new';
  },

  rulesEditHref(id) {
    return `/admin/league-rules/${encodeURIComponent(String(id))}/edit`;
  },

  accountSettingsRulesEmbed() {
    const p = stripLeagueFromAdminPath(globalThis.location.pathname || '');
    return p === '/admin/account-settings' || p.startsWith('/admin/account-settings/');
  },

  onEditClick(ev, id) {
    if (!this.accountSettingsRulesEmbed()) return;
    ev?.preventDefault?.();
    this.$store?.accountLeagueRules?.openEdit(String(id));
  },

  onNewClick(ev) {
    if (!this.accountSettingsRulesEmbed()) return;
    ev?.preventDefault?.();
    this.$store?.accountLeagueRules?.openNew();
  },

  async reload() {
    this.loading = true;
    try {
      const res = await apiFetch('/league-rules');
      const data = await res.json();
      if (!res.ok || !data?.ok) throw new Error(data?.message || 'Failed to load');
      this.items = data.items || [];
    } catch (e) {
      this.$store.toastr.error(e.message || 'Failed to load league rules');
      this.items = [];
    } finally {
      this.loading = false;
      this.refreshSpinning = false;
    }
  },

  async manualRefresh() {
    this.refreshSpinning = true;
    await this.reload();
  },

  openViewSummary(row) {
    if (!row) return;
    this.viewRowId = row._id;
    this.viewTitle = row.displayName || 'Untitled rules';
    this.viewSummaryText = buildLeagueRulesSummaryLines(row).join('\n');
    this.viewOpen = true;
  },

  closeViewSummary() {
    this.viewOpen = false;
    this.viewRowId = null;
    this.viewTitle = '';
    this.viewSummaryText = '';
  },
}));
